import { useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';

/**
 * Reactive connectivity state, backed by TanStack Query's `onlineManager`
 * (which we feed from internet reachability in `initOnlineManager`).
 */
export const useOnlineStatus = (): boolean => {
  return useSyncExternalStore(
    (onStoreChange) => onlineManager.subscribe(onStoreChange),
    () => onlineManager.isOnline(),
    () => true,
  );
};
